export default "/build/client/static/fonts/SoderbergSans-BlackItalic.woff2";